import { stubResponse } from "./settings";

export const getTableData = async() => {
    try {
        let response = await new Promise((resolve) => {
          setTimeout(() => {
            let _data = stubResponse;
            resolve(_data);
          }, 1000);
        });
        return response;
      } catch (error) {
        return Promise.reject(error);
      }
}